import React from 'react';
import loaderImg from 'assets/images/loader.svg';

function Loader() {
  return <img className='loader-image' src={loaderImg} alt='Loader' />;
}

export default Loader;
